import { Modal } from "flowbite-react";
import { FormCreateLoan } from "../form/FormCreateLoan";
import { createLoan } from "@/common/services/loans.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { ILoanRequest } from "@/types/loan.type";

type Props = {
  onClose: () => void;
}
export function ModalCreateLoan({ onClose }: Props) {


  const { notifySuccess, notifyError } = useToastContext()

  async function handleSubmit(LoanToSave: ILoanRequest) {
    try {
      const result = await createLoan(LoanToSave);
      const { ok } = result

      if (ok) {
        notifySuccess(`Solicitação criada com sucesso!`)
        onClose()
      }
      if (!result.ok) {
        notifyError(result.message as string)
      }

    } catch (err) {
      console.log(err)
      notifyError((err as Error).message as string)
    }
  }

  return (
    <Modal
      className="dark:text-black"
      size="7xl"
      show={true}
      onClose={onClose}
    >
      <Modal.Header className='text-black'>
        <h2 className='text-black'>Criar Solicitação de Empréstimo</h2>
      </Modal.Header>
      <Modal.Body className='w-full relative border-gray flex flex-col text-black'>
        <FormCreateLoan onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal >
  )
}